import React from 'react';

import {Stack, Typography} from 'views/components';

import {Translate} from 'views/module';

import {CheckCircleOutline} from 'views/icons';

const VerifiedLabel = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{
        bgcolor: '#E6FAF0',
        borderRadius: 2,
        border: 2,
        borderColor: 'grey.300',
        py: 0.5,
        px: 1.5,
      }}
    >
      <CheckCircleOutline sx={{color: '#1B5E20', fontSize: 'medium'}} />
      <Typography variant="caption" fontWeight='900' color="#1B5E20">
        <Translate expression='caregiverProfile.Header.Verified' />
      </Typography>
    </Stack>
  );
};

export default VerifiedLabel;
